import React from "react";
import {
  Avatar,
  Box,
  Container,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const FiledPayment = () => {
  const listSteps = [
    "Vuelve a la aplicación o al sitio web.",
    "Dirigirte a la sección de Membresía",
    "Intentalo nuevamente.",
    "Si el problema persiste, por favor revisa los datos proporcionados o comunícate con nuestro equipo de soporte.",
  ];
  return (
    <Container
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgba(128, 128, 128, 0.55)",
          padding: 5,
          borderRadius: 5,
          maxWidth: 450,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ErrorIcon sx={{ color: "#e80a0a", fontSize: 80 }} />
          <Typography color="#c6c6c6" variant="h5">
            Hubo un problema con tu pago.
          </Typography>
        </Box>
        <Box>
          <List sx={{ width: "100%" }}>
            {listSteps.map((step, index) => (
              <ListItem key={index}>
                <ListItemAvatar>
                  <Avatar>
                    <Typography color="#c6c6c6">{index + 1}</Typography>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={step} sx={{ color: "#dbdada" }} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Container>
  );
};

export default FiledPayment;
